<ng-template #metadataValue dsCrisLayoutLoader></ng-template>
